import script from "./gameSettings.vue?vue&type=script&lang=js"
export * from "./gameSettings.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__